export default "__VITE_ASSET__Ca80lkyf__"